export const SET_DAYEND_POPUP = "SET_DAYEND_POPUP";

export const RESET_DAYEND_POPUP = "RESET_DAYEND_POPUP";

export const SET_DAYEND_STATE = "SET_DAYEND_STATE";
export const RESET_DAYEND_STATE = "RESET_DAYEND_STATE";
